/* eslint-disable camelcase */
import React from 'react';

import ToolTip from '../../common/Tooltip';

type TRoleIcon = {
    service_key: string;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    roleItemClassName: string;
    value: string;
    name: string;
    iconName: string;
    mode: string;
    tooltip?: boolean;
    activeLabelOnClick?: (e: any) => void;
};

export function RoleIcon({
    service_key,
    handleChange,
    roleItemClassName,
    value,
    name,
    iconName,
    mode,
    tooltip,
    activeLabelOnClick,
}: TRoleIcon) {
    const button = (
        <div className={`${roleItemClassName}${service_key === value ? ' active' : ''}`}>
            <label
                className="item-circle-wrapper"
                onClick={service_key === value ? activeLabelOnClick : undefined}
            >
                <input
                    type="radio"
                    name="service"
                    value={value}
                    checked={value === service_key}
                    onChange={handleChange}
                    disabled={mode === 'edit'}
                />
                <i className={`icon ${iconName} normal`} />
                <i className={`icon ${iconName} active`} />
            </label>
            {name && !tooltip && <p className="role-item-name">{name}</p>}
        </div>
    );

    return tooltip && name ? (
        <ToolTip tooltip={name}>{button}</ToolTip>
    ) : (
        button
    );
}
